module.exports = __webpack_public_path__ + "img/en.11fc85ef.png";